import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { INotitieDb } from '../../offline/cobradb';
import { NotitiesCommonService } from '../notities-common.service';
import { AppRoutingService } from '../../app-routing.service';
import { NgFor, NgIf, DatePipe } from '@angular/common';


@Component({
    selector: 'app-notitie-list',
    templateUrl: './notitie-list.component.html',
    styleUrls: ['./notitie-list.component.scss'],
    standalone: true,
    imports: [NgFor, NgIf, DatePipe]
})
export class NotitieListComponent implements OnInit {
  @Input() notities: INotitieDb[];
  @Input() hasMoreResults?: boolean;
  @Output() getMoreResults?= new EventEmitter<void>();

  constructor(private notitieCommmonSrv: NotitiesCommonService, private routingService: AppRoutingService) { }

  ngOnInit() {
  }
  getNotitieId = (_index: number, notitie: INotitieDb) => notitie.Id;

  onGetMoreResults() {
    if (this.getMoreResults) {
      this.getMoreResults.emit();
    }
  }
  verwijderNotitie(notitie: INotitieDb) {
    this.notitieCommmonSrv.verwijderNotitie(notitie.NotitieId).subscribe(result => {
      const index = this.notities.indexOf(notitie);
      this.notities.splice(index, 1);
    });
    return false;
  }
  navigateToWijzigNotitie(notitie: INotitieDb) {
    this.routingService.navigateTo(['/notities/wijzig', notitie.ZittingId, notitie.AgendapuntId, notitie.NotitieId]);
    return false;
  }
  navigateToReageerNotitie(notitie: INotitieDb) {
    this.routingService.navigateTo(['/notities/reageer',notitie.ZittingId,notitie.AgendapuntId,notitie.NotitieId]);
    return false;
  }
}
